var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classes,
      style: { width: _vm.componentWidth },
      on: { click: _vm.toggleEditMode }
    },
    [
      _c("CompassSkeleton", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        attrs: { size: "x-large" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ],
          ref: "dropdownTrigger",
          staticClass: "edit-multiple-users__content"
        },
        [
          _vm.formattedSharedStaff.length > 0
            ? _c("CompassMultiAvatar", {
                attrs: { size: "small", avatars: _vm.formattedSharedStaff }
              })
            : _c(
                "CompassTooltip",
                {
                  attrs: {
                    arrow: false,
                    content: _vm.$t.__(
                      "overview.opportunity.editMultipleUsers.assign_workers"
                    )
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "edit-multiple-users__empty" },
                    [
                      _c("CompassAvatar", {
                        attrs: {
                          size: "small",
                          initials: "",
                          photo:
                            "/ressources/logged/img/illustrations/avatar.svg"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "edit-multiple-users__empty-add" },
                        [
                          _c("CompassIcon", {
                            attrs: { icon: "plus", size: "small" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDropdown",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleCancel,
              expression: "handleCancel"
            }
          ],
          attrs: {
            parentRef: "dropdownTrigger",
            isVisible: _vm.editMode,
            filterable: "",
            appliedButton: _vm.$t.__("common.actions.apply"),
            noResultsLabel: _vm.$t.__("common.labels.no_result"),
            filterablePlaceholder: _vm.$t.__("common.actions.search"),
            multiple: _vm.multiple
          },
          on: {
            onApplied: _vm.handleValueUpdate,
            change: _vm.handleValueChange
          },
          model: {
            value: _vm.selectedUsers,
            callback: function($$v) {
              _vm.selectedUsers = $$v
            },
            expression: "selectedUsers"
          }
        },
        _vm._l(_vm.formattedStaff, function(staff) {
          return _c("CompassDropdownOption", {
            key: staff.value,
            attrs: {
              value: staff.value,
              label: staff.fullname,
              selected: staff.selected,
              type: "avatar",
              avatar: staff.avatar
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }